import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/zo4k7zg8_LOGOfondo.jpg";

const NAV = [
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Plataforma RP", href: "#plataforma" },
  { label: "Por qué elegirnos", href: "#beneficios" },
  { label: "Contacto", href: "#contacto" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md shadow-[0_8px_30px_-15px_rgba(60,57,80,0.15)]"
          : "bg-transparent"
      }`}
    >
      <div className="rp-container flex items-center justify-between py-3 sm:py-4">
        <a href="#top" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="Contadores RP" className="h-20 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-[color:var(--rp-blue)] transition-colors relative group"
            >
              {n.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[color:var(--rp-green)] transition-all group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="https://calendly.com/contadoresrp"
            target="_blank"
            rel="noreferrer"
            data-testid="header-cta-calendly"
            className="rp-btn rp-btn-primary hidden md:inline-flex text-sm"
          >
            <Phone className="w-4 h-4" />
            Agenda tu diagnóstico
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-lg border border-slate-200 bg-white"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-slate-100">
          <div className="rp-container py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-2 text-base font-medium text-slate-700"
              >
                {n.label}
              </a>
            ))}
            <a
              href="https://calendly.com/contadoresrp"
              target="_blank"
              rel="noreferrer"
              className="rp-btn rp-btn-primary justify-center mt-2"
            >
              Agenda tu diagnóstico
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
